export default __webpack_public_path__ + "static/media/pic70.e91c59ac.jpg";